const name = 'circle-2';


const contents = `
<circle cx="31" cy="41" r="29"/>
<path d="M41.15 55h-20.3v-4.226a247.272 247.272 0 006.339-5.22c1.74-1.491 3.148-2.817 4.225-3.977 1.077-1.16 1.865-2.223 2.362-3.19.497-.967.745-1.92.745-2.858 0-.884-.165-1.63-.497-2.238A4.313 4.313 0 0032.7 31.8a4.905 4.905 0 00-1.782-.787 8.412 8.412 0 00-1.781-.207c-.94 0-2.003.11-3.19.331-1.188.221-2.555.635-4.102 1.243l-.911-3.894a27.819 27.819 0 014.35-1.492c1.519-.386 3.19-.58 5.013-.58 3.093 0 5.51.787 7.25 2.362 1.74 1.574 2.61 3.549 2.61 5.924 0 1.657-.373 3.176-1.119 4.557-.746 1.381-1.726 2.707-2.941 3.977a40.63 40.63 0 01-4.06 3.687 892.855 892.855 0 01-4.557 3.605v.497l4.888-.829h8.783V55z" fill="#FFF"/>
`;


/** @type {import ('./types').CharacterIcon} */
const icon = {
  name,
  contents,
  iconCharacter: '2',
};

export default icon;
